export default __webpack_public_path__ + "static/media/nintendo.f579be04.svg";